import { useEffect, FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Card, CardContent, Divider, Grid, ThemeProvider, Typography, createTheme } from '@mui/material';
import { useStyles } from "../../common/appStyles";
import logo from "../../images/YEP - Logo.png";

/**
 * @returns html component using a card for landing page elements
 * @remarks The starting landing page for the whole web application.
 * The page has two buttons one for registering and one for logging in.
 */
export const Landing: FunctionComponent = () => {
    const classes = useStyles();
    const { loginWithRedirect, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();

    const theme = createTheme({
        palette: {
            primary: {
                main: '#484A57'
            },
            secondary: {
                main: '#10AD61'
            },
            background: {
                default: '#ffffff'
            },
        },
        typography: {
            h6: {
                color: '#484A57'
            },
            body1: {
                color: '#00000'
            }
        },
    });

    const onLogin = async () => {
        await loginWithRedirect();
    };

    const onSignup = async (event: any) => {
        navigate("/registration")
    }

    useEffect(() => {

        const fetchTokenAndNavigate = async () => {
            if (isLoading) {
                return;
            }
        };
        fetchTokenAndNavigate();
    }, [isAuthenticated, navigate, loginWithRedirect, getAccessTokenSilently, isLoading]);

    useEffect(() => {
        navigate('/landing')
    }, [])

    return (
        <div className={classes.wrapper} >
            <ThemeProvider theme={theme}>
                <Grid container style={{ height: '100vh' }} bgcolor='#484A57' alignItems={'center'} direction={"column"} justifyContent={"center"}>
                    <Grid item xs={12} >
                        <Grid container sx={{ flexGrow: 1 }} style={{ height: '100vh' }} justifyContent={"center"} alignItems={"center"}  >
                            <Card sx={{ minWidth: 390, minHeight: 470, flexGrow: 1, borderRadius: 2 }} elevation={10} >
                                <Grid className={classes.gridPaddingTop}>
                                    <span className="landing-logo">
                                        <Grid container justifyContent={'center'} alignItems={"center"}>
                                            <img src={logo} width={'200vh'} height={'auto'} alt="YEC" />
                                        </Grid>
                                    </span>
                                </Grid>
                                <CardContent >
                                    <Typography variant="body2" color="text.secondary" textAlign={'center'} sx={{ mt: 1, mb: 1 }}>
                                        Insert YEC Slogan or some other text here
                                    </Typography>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        padding={"5px"}
                                        sx={{ mt: 1, mb: 1 }}
                                    >
                                        <Grid item xs={5}>
                                            <Button onClick={onLogin} variant="contained" fullWidth size="large" color="secondary" >Log in</Button>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <Divider variant='middle' sx={{ background: "black", marginTop: "2vh" }} />
                                <CardContent style={{ marginTop: "2.5vh" }}>
                                    <Typography variant="body2" color="text.secondary" textAlign={'center'} sx={{ mb: 1 }}>
                                        Don't have an account?
                                    </Typography>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        padding={"5px"}
                                        sx={{ mt: 1, mb: 1 }}
                                    >
                                        <Grid item xs={5}>
                                            <Button onClick={onSignup} variant="outlined" fullWidth size="large" color="secondary" >Sign Up</Button>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </ThemeProvider>
        </div>
    );
};

